import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PostHooks from "../../../Hooks/PostHooks";
import UpdateHooks from "../../../Hooks/UpdateHooks";
import { Icon } from "@iconify/react";
import { useQuery } from "../../../Hooks/useApi";

const SuperAdminHomeState = () => {
  const { data: homeStateResponse } = useQuery("/homeState/getHomeState");
  const [formData, setFormData] = useState({
    city: 0,
    awards: 0,
  });

  useEffect(() => {
    if (homeStateResponse?.data?.length) {
      setFormData(homeStateResponse.data[0]);
    }
  }, [homeStateResponse]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (formData?._id) {
        await UpdateHooks(
          `https://servercareseebd.careseebd.com/api/v1/homeState/updateHomeState/${formData?._id}`,
          { ...formData }
        );
        toast.success("HomeState section updated successfully!");
      } else {
        await PostHooks(
          `https://servercareseebd.careseebd.com/api/v1/homeState/addHomeState`,
          { ...formData },
          "homeState data posted"
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="max-w-4xl mx-auto select-none space-y-6">
      {/* Header bar */}
      <div className="flex items-center gap-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm">
        <div className="p-3 bg-indigo-50 text-indigo-600 rounded-xl">
          <Icon icon="solar:presentation-graph-bold" className="w-6 h-6" />
        </div>
        <div>
          <h1 className="text-lg font-black text-slate-800 tracking-tight">Home Statistics Settings</h1>
          <p className="text-xs text-slate-400 font-semibold mt-0.5">Edit home counter statistics (cities served, awards won)</p>
        </div>
      </div>

      {/* Main card */}
      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 lg:p-8">
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div className="space-y-1.5">
              <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Cities Covered</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                  <Icon icon="solar:city-outline" className="w-4 h-4" />
                </div>
                <input
                  type="number"
                  name="city"
                  required
                  onChange={handleChange}
                  value={formData.city}
                  placeholder="e.g. 50"
                  className="w-full pl-10 pr-3 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
                />
              </div>
            </div>

            <div className="space-y-1.5">
              <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">Awards Won</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400">
                  <Icon icon="solar:cup-outline" className="w-4 h-4" />
                </div>
                <input
                  type="number"
                  name="awards"
                  required
                  onChange={handleChange}
                  value={formData.awards}
                  placeholder="e.g. 10"
                  className="w-full pl-10 pr-3 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-xs font-semibold text-slate-800"
                />
              </div>
            </div>
          </div>

          <div className="pt-2">
            <button
              type="submit"
              className="w-full py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-95 text-white font-extrabold text-xs rounded-xl shadow-md shadow-cyan-500/10 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer"
            >
              Update Home State Stats
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SuperAdminHomeState;
